<script setup lang="ts">
import Hero from '~/components/block/Hero.vue';
import RichText from '~/components/block/RichText.vue';
import Gallery from '~/components/block/Gallery.vue';
import Pricing from '~/components/block/Pricing.vue';
import Posts from '~/components/block/Posts.vue';
import Form from '~/components/block/FormBlock.vue';
import BlockPages from '~/components/block/BlockPages.vue';
import BlockSteps from '~/components/block/BlockSteps.vue';
import BlockKPIs from '~/components/block/BlockKPIs.vue';
import BlockFaqs from '~/components/block/BlockFaqs.vue';
import BlockTeam from '~/components/block/BlockTeam.vue';
import Wizard from '~/components/block/Wizard.vue';

interface BaseBlockProps {
	block: {
		collection: string;
		item: any;
		id: string;
		background?: 'light' | 'dark' | null;
	};
	pageId?: string;
}

const props = defineProps<BaseBlockProps>();
const blockRef = ref<HTMLElement | null>(null);

const components: Record<string, any> = {
	block_hero: Hero,
	block_richtext: RichText,
	block_gallery: Gallery,
	block_pricing: Pricing,
	block_posts: Posts,
	block_form: Form,
	block_pages: BlockPages,
	block_steps: BlockSteps,
	block_kpis: BlockKPIs,
	block_faqs: BlockFaqs,
	block_team: BlockTeam,
	block_wizard: Wizard,
};

const Component = computed(() => components[props.block.collection] || null);
const componentData = computed(() => props.block.item);

const isFullWidthHero = computed(() => {
	return props.block.collection === 'block_hero' && props.block.item?.layout === 'image_background';
});

const isFullWidthBlock = computed(() => {
	return isFullWidthHero.value || 
		(props.block.collection === 'block_kpis' && props.block.item?.background_image) ||
		(props.block.collection === 'block_form' && props.block.item?.background_image) ||
		props.block.collection === 'block_wizard';
});
</script>

<template>
	<div v-if="!isFullWidthBlock" ref="blockRef" class="relative">
		<component :is="Component" v-if="Component" :id="`block-${block.id}`" :data="componentData" :background="block.background" :page-id="pageId" />
	</div>
	<component v-else :is="Component" v-if="Component" :id="`block-${block.id}`" :data="componentData" :background="block.background" :page-id="pageId" />
</template>
